import { formatDate } from 'date-fns'
import React, { useEffect, useState } from 'react'
import wea from './wea.module.css'
import { format } from 'date-fns';
import { TiWeatherCloudy } from 'react-icons/ti';
import axios from 'axios';
const Weathers = () => {
   

    const [weather, setWeather] = useState(null)
    const defaultCity = 'Lagos';
    const apiKey = '35006a89501bd6bf6194d4cfab04ce30';

  useEffect(() => {
    const getWeather = async()=>{
      try{
        const response = await axios.get(`https://api.openweathermap.org/data/2.5/weather?q=${defaultCity}&appid=${apiKey}&units=metric`);
        setWeather(response.data)
      }catch(error){
        console.error('Error fetching the weather data:', error);
      };
      
  }

  getWeather()
  }, [defaultCity ,apiKey])
  

  return (
    <div className={wea.wea }>
        <div className={wea.flexI}>
        {weather && (
          <div className={wea.flex}> 
            <TiWeatherCloudy className={wea.icon} />
            <p>{weather.main.temp} °C</p>
          </div>
        )}
        </div>
        <div className={wea.flexII}>
        <h2 className={wea.Date}>{format(new Date() , "d , MMM yyyy")}</h2>
        </div>
    </div>
  )
}

export default Weathers 
